import { SortingState } from "@tanstack/react-table";

export const parseSorting = (sorting?: SortingState) => ({
  direction: sorting?.[0]?.desc ? "desc" : "asc"
});
